import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

if (typeof window !== 'undefined' && window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = document.getElementById('root')!
const app = (<StrictMode>
    <App />
  </StrictMode>)

if (root.hasChildNodes()) {
  hydrateRoot(root, app)
} else {
  createRoot(root).render(app)
}
